module.exports = __webpack_public_path__ + "img/career-details.9e8948f1.jpg";